import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { BookOpenTextOutlined as e$1 } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/book-open-text-outlined.es.es.js";
import { BoxOutlined as i$1 } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/box-outlined.es.es.js";
import { EuroCircleOutlined as n$1 } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/euro-circle-outlined.es.es.js";
import { FileTextEditOutlined as H } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/file-text-edit-outlined.es.es.js";
import { HomeOutlined as n } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/home-outlined.es.es.js";
import { InfoCircleOutlined as t } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/info-circle-outlined.es.es.js";
import { ListOutlined as n$4 } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/list-outlined.es.es.js";
import { LogOutOutlined as n$3 } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/log-out-outlined.es.es.js";
import { MoreHorizontalOutlined as n$2 } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/more-horizontal-outlined.es.es.js";
import { NoteTextOutlined as i } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/note-text-outlined.es.es.js";
import { SettingsOutlined as o } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/settings-outlined.es.es.js";
import { UserCircleOutlined as e } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/user-circle-outlined.es.es.js";
import { UsersGroupAltOutlined as n$5 } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/users-group-alt-outlined.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
const SIDEBAR_ICON_SIZE = "1.219rem";
const sidebarRoutes = [{
  label: "Home",
  icon: /* @__PURE__ */ jsx(n, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Profilo",
  icon: /* @__PURE__ */ jsx(e, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Bonus",
  icon: /* @__PURE__ */ jsx(n$1, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Pratiche",
  icon: /* @__PURE__ */ jsx(H, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Altro",
  icon: /* @__PURE__ */ jsx(n$2, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE }),
  disabled: true
}, {
  label: "Documenti",
  icon: /* @__PURE__ */ jsx(i, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Impostazioni",
  icon: /* @__PURE__ */ jsx(o, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Tutorial",
  icon: /* @__PURE__ */ jsx(t, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  icon: /* @__PURE__ */ jsx(i$1, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE }),
  label: "Scartoffie",
  subpaths: [{
    label: "Termini di utilizzo"
  }, {
    label: "Condizioni Generali di Servizio"
  }, {
    label: "Privacy Policy"
  }, {
    label: "Cookies Policy"
  }]
}, {
  label: "Logout",
  icon: /* @__PURE__ */ jsx(n$3, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}];
const adminRoutes = [{
  label: "Home",
  icon: /* @__PURE__ */ jsx(n, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Configurazioni",
  icon: /* @__PURE__ */ jsx(o, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE }),
  subpaths: [{
    label: "Documenti"
  }, {
    label: "Avanzate"
  }, {
    label: "Sconti"
  }]
}, {
  label: "Pratiche",
  icon: /* @__PURE__ */ jsx(n$4, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Anagrafica",
  icon: /* @__PURE__ */ jsx(n$5, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE }),
  subpaths: [{
    label: "Utenti"
  }, {
    label: "Enti Partner"
  }]
}, {
  label: "Più",
  disabled: true
}, {
  label: "Guida",
  icon: /* @__PURE__ */ jsx(e$1, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Logout",
  icon: /* @__PURE__ */ jsx(n$3, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}];
const operatorRoutes = [{
  label: "Home",
  icon: /* @__PURE__ */ jsx(n, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Pratiche",
  icon: /* @__PURE__ */ jsx(n$4, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Anagrafica",
  icon: /* @__PURE__ */ jsx(n$5, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Più",
  disabled: true
}, {
  label: "Guida",
  icon: /* @__PURE__ */ jsx(e$1, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}, {
  label: "Logout",
  icon: /* @__PURE__ */ jsx(n$3, { width: SIDEBAR_ICON_SIZE, height: SIDEBAR_ICON_SIZE })
}];
export {
  adminRoutes,
  operatorRoutes,
  sidebarRoutes
};
//# sourceMappingURL=routes.es.js.map
